import React, { useEffect, useState } from "react";
import "./Step_2_1.css";

import Summery_holder from "../../summery_holder/Summery_holder";
import Step1_Account from "./step1_Account/Step1_Account";
import Step2_FlatRate from "./step2_FlatRate/Step2_FlatRate";
import Step3_Payment from "./step3_Payment/Step3_Payment";
import Step4_Delivery from "./step4_Delivery.js/Step4_Delivery";

import Step4_Delivery_Shipping from "./step4_Delivery.js/Step4_Delivery_Shipping";
import { getAllPricesLuxury, getCartLuxury } from "../../../../utils/luxuryapis/addToCart/addToCart";
import Summery_holder_order from "../../summery_holder/Summery_holder_order";

function Step_2_1({
  setCheckoutStep,
  setActiveStep,
  step2ActiveSection,
  setStep2ActiveSection,
  giftData,
  setGiftData,
  shippingAddrress,
  setShippingAddress,
  billingAddrress,
  setBillingAddress,
  sameShippingAddress,
  setSameShippingAddress,
  paymentMethod,
  setPaymentMethod,
  hasGiftItems,
  setHasGiftItems,
  giftEntireOrder,
  setGiftEntireOrder,
  giftIndividualItems,
  setGiftIndividualItems,
  cartData,
  user,
}) {
  const [activeSection, setActiveSection] = useState(step2ActiveSection || 1);

  useEffect(() => {
    if (step2ActiveSection) {
      setActiveSection(step2ActiveSection);
    }
  }, [step2ActiveSection]);

  // Internal steps navigation
  const goToStep = (step) => {
    setActiveSection(step);
    setStep2ActiveSection(step);

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 150);
  };

  const goToCartStep3 = () => {
    setActiveStep(3);

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 150);
  };

  const [allPrice, setAllprice] = useState();
  const AllPriceGet = async () => {
    const res = await getAllPricesLuxury();
    if (res?.success) {
      setAllprice(res?.data);
      // finalFunction();
    } else {
      console.error("Error fetching data:", res?.error);
    }
  };
  useEffect(() => {
    AllPriceGet();
  }, []);
  return (
    <section className="cart_step_content Step_2_1">
      <div className="row">
        <div className="col-md-8">
          {activeSection === 1 && (
            <Step1_Account
              user={user}
              goToStep={goToStep}
              setShippingAddress={setShippingAddress}
              shippingAddrress={shippingAddrress}
              billingAddrress={billingAddrress}
              setBillingAddress={setBillingAddress}
              sameShippingAddress={sameShippingAddress}
              setSameShippingAddress={setSameShippingAddress}
            />
          )}

          {activeSection === 2 && (
            <Step2_FlatRate
              user={user}
              setGiftIndividualItems={setGiftIndividualItems}
              giftIndividualItems={giftIndividualItems}
              giftEntireOrder={giftEntireOrder}
              setGiftEntireOrder={setGiftEntireOrder}
              hasGiftItems={hasGiftItems}
              setHasGiftItems={setHasGiftItems}
              goToStep={goToStep}
              cartData={cartData}
              setGiftData={setGiftData}
              giftData={giftData}
            />
          )}

          {activeSection === 3 && (
            <Step3_Payment
              user={user}
              goToStep={goToStep}
              goToCartStep3={goToCartStep3}
              setPaymentMethod={setPaymentMethod}
              paymentMethod={paymentMethod}
            />
          )}

          {activeSection === 4 && (
            <Step4_Delivery goToStep={goToStep} user={user} />
          )}

          {activeSection === 5 && (
            <Step4_Delivery_Shipping
              user={user}
              goToStep={goToStep}
              setShippingAddress={setShippingAddress}
              shippingAddrress={shippingAddrress}
            />
          )}
        </div>

        <div className="col-md-4">
          <Summery_holder_order allPrice={allPrice} />
        </div>
      </div>
    </section>
  );
}

export default Step_2_1;
